<header class="topbar-shell" *ngIf="{ uploaded: (isFileUploaded$ | async), summary: (regionSelection$ | async), file: (uploadedFileMetadata$ | async) } as vm">
  <nav class="topbar">
    <div class="topbar__brand">
      <div class="topbar__logo">PaScal Viewer</div>
      <a
        *ngIf="vm.file as file"
        class="topbar__file-link"
        [href]="file.jsonViewUrl"
        target="_blank"
        rel="noopener noreferrer"
        [title]="'Open ' + file.fileName"
      >
        {{ file.fileName }}
      </a>
    </div>
    <ul class="topbar__menu">
      <li><a href="#" (click)="goHome($event)">Home</a></li>
      <li><a href="#" (click)="goGuide($event)">Guide</a></li>
      <li *ngIf="vm.uploaded"><a href="#" (click)="newAnalysis($event)">New Analysis</a></li>
      <!-- <li><a href="#">About</a></li> -->
      <!-- <li><a href="#">Contact</a></li> -->
    </ul>
  </nav>

  <app-topbar-region-info *ngIf="vm.uploaded" [summary]="vm.summary"></app-topbar-region-info>
</header>
